<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-6">
               <h1><span style="color:#00a65a">{{com_TVOwnerName()}}</span> Online PIN Activation</h1>
            </div>
            <div class="col-xs-6 mandatoryDiv">
               <span class="mandatory_color">(*)</span> <span class="letter-right"> Marked are required field</span>
            </div>
         </div>
      </section>
      <section class="content">
         <div class="row">
            <div class="col-sm-12">
               <div class="alert alert-info" v-if="alert_message">
                  {{alert_message}}
               </div>
            </div>
               <div class="col-sm-7">
                  <div class="box">
                     <div class="box-header">
                        <h3 class="box-title">
                           PIN Information
                        </h3>
                     </div>
                     <div class="box-body form-box-body form-horizontal">
                        <div class="form-group">
                           <label class="col-md-4 control-label">Payment Gateway <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                           <select title="" name="payment_gate_way" v-model="payment_gate_way" v-select="payment_gate_way" id="payment_gate_way" class="form-control input-sm select2" @change="changeFields">
                              <option value="8">Offline Payment</option>
                              <option value="1">SSL Payment</option>
                           </select>
                           </div>
                        </div>

                        <div v-if="!isOfflinePayment">
                           <div class="form-group">
                              <label class="col-md-4 control-label">Payment TNX ID <span class="mandatory_horizontal required-sign">*</span></label>
                              <div class="col-md-8">
                                 <input name='tnx_id' id='tnx_id' class="form-control input-sm" v-model="tnx_id" value='' placeholder="Enter Payment Success TNX ID" type="text" autocomplete="off" onfocus="this.removeAttribute('readonly');" readonly>
                                 <label v-if="error_tnx_id" class="error" for="tnx_id">{{error_tnx_id}}</label>
                              </div>
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">Price USD  <span class="mandatory_horizontal required-sign">*</span></label>
                           <div class="col-md-8">
                              <input name='price' v-model="price" id='price' class="form-control input-sm number" value='' placeholder="Price" type="number" onfocus="this.removeAttribute('readonly');" readonly>
                              <label v-if="error_price" class="error" for="price">{{error_price}}</label>
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">TV (Username/PIN)  <span class="mandatory_horizontal required-sign">*</span></label>
                           <div class="col-md-8">
                              <input name='username' v-model="username" id='username' class="form-control input-sm " value='' placeholder="Enter Username" type="text" autocomplete="off" onfocus="this.removeAttribute('readonly');" readonly>
                              <label v-if="error_username" class="error" for="username">{{error_username}}</label>
                           </div>
                       </div>

                       <div v-if="isOfflinePayment">
                           <div class="form-group">
                              <label class="col-md-4 control-label"> Payment Via <span class="mandatory_horizontal">*</span></label>
                              <div class="col-md-8">
                                 <select title="" name="payment_via" v-model="payment_via" id="payment_via" class="form-control input-sm">
                                       <option value="0">Others</option>
                                       <option value="1">Hand Cash</option>
                                       <option value="2">Bank Deposit</option>
                                       <option value="3">Internet Banking</option>
                                       <option value="4">Mobile Bank</option>
                                       <option value="5">To Personal AC</option>
                                       <option value="6">Stripe Payment</option>
                                 </select>
                              </div>
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">TV Subscription Plan<span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <select title="" name="plan_id" v-model="plan_id" id="plan_id" class="form-control input-sm" onfocus="this.removeAttribute('readonly');" readonly="">
                                 <option value="">Select a Plan</option>
                                 <option v-for="(data) in rateplans" :key="data.id" :value="data.id">
                                    {{data.plan_name}}
                                 </option>
                              </select>
                              <label v-if="error_plan_id" class="error" for="plan_id">{{error_plan_id}}</label>
                           </div>
                        </div>
                             
                        <div class="form-group">
                           <label class="col-md-4 control-label">Remarks  </label>
                           <div class="col-md-8">
                              <textarea name="remarks" v-model="remarks" id="remarks" class="form-control input-sm" onfocus="this.removeAttribute('readonly');" readonly></textarea>
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">Payment Date  <span class="mandatory_horizontal required-sign">*</span></label>
                           <div class="col-md-8">
                              <input placeholder="Payment Date" type="text" value="" name="payment_date" id="payment_date" v-model="payment_date" autocomplete="off" class="form-control input-sm datePicker">
                              <label v-if="error_payment_date" class="error" for="payment_date">{{error_payment_date}}</label>
                           </div>
                        </div>

                     </div>
                  </div>
               </div>
               <div class="col-sm-12 btnCenter">
                  <input type="submit" name="submit" value="Generate" class="btn btn-sm btn-submit btn-submit-big" @click="formSubmit">
               </div>
         </div>
      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   export default {
     name: "FlexSinglePinActivation",
     data() {
         return {
            userData : {},
            rateplans : {},
            username : '',
            plan_id : '',
            payment_gate_way : 8,
            tnx_id : '',
            price : '',
            payment_via : 0,
            remarks : '',
            payment_date : '',
            isOfflinePayment : true,
            alert_message : '',
            flexApiUrl : process.env.VUE_APP_APIFLEXURL,
            error_username : false,
            error_plan_id : false,
            error_tnx_id : false,
            error_price : false,
            error_payment_date : false,

         }
      },
      created(){
         if(!this.com_isTVReseller(true, [393, 395])){
            this.$router.push('dashboard');
         }
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         this.userData = JSON.parse(decodedString);
         var rootObject = this;
         loader.show();
         rootObject.loadRatePlans();
      },
      methods: {
         changeFields() {
            this.isOfflinePayment = false;
            if(this.payment_gate_way != 1){
               this.isOfflinePayment = true;
            }
         },

         loadRatePlans(){
            var rootObject = this;
            var idReseller = rootObject.userData.id_reseller;
            var level = rootObject.userData.user_level;
            var queryStr = "?idReseller="+idReseller+"&level="+level;
            axios.get(rootObject.flexApiUrl+'/get-rates-by-plan-id'+queryStr).then(function (response){
               //console.log(response)
               rootObject.rateplans = response.data;
               rootObject.plan_id = '';
               loader.hide();
            })
            .catch(function (error) {
               let alertmessage = "";
               for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
               }
               console.log(alertmessage); 
               loader.hide();
               rootObject.com_errorHandel(error);
            });
         },

         formSubmit(e) {
            e.preventDefault();
            var rootObject = this;
            var result = this.fromValidation();
            if (result) {
               setTimeout(function(){  
                  rootObject.error_username = false;
                  rootObject.error_plan_id = false;          
                  rootObject.error_tnx_id = false;
                  rootObject.error_price = false;
                  rootObject.error_payment_date = false;
               }, 5000);
               return 0;
            }

            loader.show(); 
            const form = new FormData()
            form.append('username', this.username)
            form.append('rate_plan_id', this.plan_id)
            form.append('plan_id', this.plan_id)
            form.append('payment_gate_way', this.payment_gate_way)
            form.append('tnx_id', this.tnx_id)
            form.append('price', this.price)
            form.append('payment_via', this.payment_via)
            form.append('remarks', this.remarks)
            form.append('payment_date', this.payment_date)
            form.append('id_reseller', rootObject.userData.id_reseller)
            form.append('level', rootObject.userData.user_level)
            form.append('tv_pin_prefix', rootObject.userData.reseller4.tv_pin_prefix)

            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }

            axios.post(rootObject.flexApiUrl+'/online-pin-activation', form, config)
            .then(function (response) {
               //console.log(response.data);
               rootObject.alert_message =  response.data;
               rootObject.username = '';
               rootObject.plan_id = '';
               rootObject.payment_gate_way = 8;
               rootObject.tnx_id = '';
               rootObject.price = '';
               rootObject.payment_via = 0;
               rootObject.remarks = '';
               loader.hide(); 
            })
            .catch(function (error) {
               loader.hide(); 
               let alertmessage = "";
               for (var prop in error.response.data) {
                   alertmessage += ' '+error.response.data[prop]
               }
               console.log(alertmessage);
               rootObject.alert_message =  alertmessage;
               rootObject.com_errorHandel(error);
            });
            setTimeout(function(){  
               rootObject.alert_message = '';
               rootObject.error_username = false;
               rootObject.error_plan_id = false;          
               rootObject.error_tnx_id = false;
               rootObject.error_price = false;
               rootObject.error_payment_date = false;
            }, 5000);
         },

         fromValidation(reset = false){
            var has_error = false;
            if(!this.username){
               this.error_username = "This field is required";
               has_error = true;
            }

            if(!this.price){
               this.error_price = "This field is required";
               has_error = true;
            }

            if(!this.payment_date){
               this.error_payment_date = "This field is required";
               has_error = true;
            }

            if(!this.plan_id){
               this.error_plan_id = "This field is required";
               has_error = true;
            }

            if(!this.isOfflinePayment){
               if(!this.tnx_id){
                  this.error_tnx_id = "This field is required";
                  has_error = true;
               }  
            }

            if (has_error) {
               return true;
            }else{
               return false;
            }
         }

      },
      mounted: function() {
         var rootObject = this;
         $(".select2").select2();
         $(".stop-negative-value").keydown(function(e){
            if(!((e.keyCode > 95 && e.keyCode < 106)
               || (e.keyCode > 47 && e.keyCode < 58) 
               || e.keyCode == 8)) {
                 return false;
            }
         });

         $(".stop-specialchar").keypress(function(e){
            var keyCode = e.keyCode || e.which;
            var regexp = new RegExp("^[a-zA-Z0-9]+$");
            var result = regexp.test(String.fromCharCode(keyCode));
            if(!result){
               return false;
            }
         });

         $('#payment_date').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.payment_date = $(this).val();
         });

      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .displayhide{
      display: none;
   }
</style>